import { Component, OnInit, } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { RegistrationService } from '../../../services/registration.service';
import { Router } from '@angular/router';
import { RegistrationComponent } from '../../registration/registration.component';

@Component({
    selector: 'app-registration-page',
    imports: [RegistrationComponent],
    templateUrl: './registration-page.component.html',
    styleUrls: ['./registration-page.component.css']
})
export class RegistrationPageComponent implements OnInit {

  constructor(private http: HttpClient,
    private registrationService: RegistrationService,
    private router: Router) { }

  ngOnInit() {
  }
}
